import Router from "./configurations-router";

import ConfigurationsComponent from "./configurations-component";
import ConfigurationListComponent from "./configuration-list/configuration-list.component";
import ConfigurationUpdateComponent from "./configuration-update/configuration-update.component";
import QuickSetupComponent from "./quick-setup/quick-setup.component";
import ScenesComponent from "./scenes/scenes.component";
import ScenesListComponent from "./scenes-list/scenes-list.component";
import LiveViewComponent from "./live-view/live-view.component";


const Module = angular
    .module("app.configurations", [])
    .component("configurations", ConfigurationsComponent)
    .component("configurationList", ConfigurationListComponent)
    .component("configurationUpdate", ConfigurationUpdateComponent)
    .component("quickSetup", QuickSetupComponent)
    .component("scenes", ScenesComponent)
    .component("liveView", LiveViewComponent)
    .component("scenesList", ScenesListComponent)
    .config(Router);

export default Module;


// WEBPACK FOOTER //
// ./sources/components/configurations/configurations-module.js